import React, {useEffect, useState} from 'react';
import ReactConnectElements from "@/Plugins/ConnectNodes";

import {ComparisonSlider} from "react-comparison-slider";
import SliderBnA from "@/Plugins/BA/SliderBnA";
import gsap from "gsap";
import ParallaxBA from "@/Components/Front/ParallaxBA";
import ParallaxBAB from "@/Components/Front/ParallaxBAB";
import ChevronLeft from "@/Components/Front/SVGS/ChevronLeft";
import ChevronRight from "@/Components/Front/SVGS/ChevronRight";
import Circle from "@/Components/Front/SVGS/Circle";
import {useMediaQuery} from "react-responsive";


const DemoCreateEls = ({textProps}) => {

    const [toggle, setToggle] = useState(false);
    const [, updateState] = useState();

    const [inc, setInc] = useState(0);
    const [off, setOff] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const [animations, setAnimations] = useState(null);
    const isSm = useMediaQuery({query: '(min-width: 640px)'})
    const isMobile = useMediaQuery({query: '(max-width: 639px)'});
    const [value, setValue] = useState(isMobile ? 50 : 35);

    useEffect(() => {
        // console.log(animations, "animations in useEffect");

        setOff(false);
        setTimeout(() => {
            setOff(true);
        }, 0);
    }, [inc, animations]);


    useEffect(() => {

        setLoaded(true);
        const inframe = document.querySelectorAll(".roe");

        const width = inframe[0].offsetWidth;

        setInc((width / 100 * value))
    }, [value])

    useEffect(() => {
            if (loaded) {
                gsap.timeline({
                        defaults: {duration: 1},
                        scrollTrigger: {
                            trigger: "#path1",
                            // markers: {startColor: "white", endColor: "white"},
                            scrub: true,
                            start: "top center",
                            end: "bottom bottom",
                            onUpdate: self => {
                                if (isSm) {
                                    setAnimations({index: 0, progress: self.progress.toFixed(3), direction: self.direction, show:false})

                                } else {
                                    setAnimations({index: 0, progress: 100, direction: self.direction, show:true})

                                }
                            },


                        }

                    }
                )
                gsap.timeline({
                    defaults: {duration: 1},
                    scrollTrigger: {
                        trigger: "#path2",
                        // markers: {startColor: "white", endColor: "white"},
                        scrub: true,
                        start: "top bottom-=100px",
                        end: "bottom bottom",
                        onUpdate: self => {

                            if (isSm) {
                                setAnimations({index: 1, progress: self.progress.toFixed(3), direction: self.direction, show:false})

                            } else {
                                setAnimations({index: 1, progress: 100, direction: self.direction,show:true})

                            }
                        },


                    }

                })

                gsap.timeline({
                        defaults: {duration: 1},
                        scrollTrigger: {
                            trigger: "#path3",
                            // markers: {startColor: "white", endColor: "white"},
                            scrub: true,
                            start: "top bottom-=100px",
                            end: "bottom bottom",
                            onUpdate: self => {

                                if (isSm) {
                                    setAnimations({index: 2, progress: self.progress.toFixed(3), direction: self.direction, show:false})

                                } else {
                                    setAnimations({index: 2, progress: 100, direction: self.direction, show: true})

                                }
                            },


                        }

                    }
                )
            }
        }, [loaded, isSm]
    )
    return (
        <div className="container-el">

            <div className="elements">
                <div className={"compare-compo"}>
                    <ComparisonSlider
                        value={value}
                        onValueChange={setValue}
                        itemOne={
                            <ParallaxBAB textProps={textProps}/>
                        }
                        itemTwo={
                            <ParallaxBA textProps={textProps}/>
                        }

                        handleAfter={<div className=" w-1 bottom-0 h-full"/>}
                        handleBefore={<div className=" w-1 bottom-0 h-full"/>}
                        aspectRatio={1 / (isSm ? 1 : 2)}
                        onlyHandleDraggable={true}
                        handle={(props) => {
                            return (
                                <div
                                    onDoubleClick={() => {
                                        setValue(50);
                                    }}
                                    className="target-handler bg-white text-white h-20 w-20 rounded-full flex items-center justify-center"
                                >
                                    <ChevronRight/>
                                    <ChevronLeft/>
                                </div>
                            );
                        }}
                    />

                </div>
                <div className="roe">

                    <div className="element element0"/>
                    <div className='element element1'/>
                    <div className="element element2"/>
                </div>
            </div>
            <div className="space"/>

            <div className="elements">
                <div className="roe">
                    <div
                        className="element element3"
                        style={{transform: 'translateX(' + inc + 'px)'}}
                    />
                </div>
            </div>
            <div className="space space2"/>

            <div className="elements">
                <div className="roe">
                    <div className="element element11">
                        {isMobile &&
                            <Circle/>
                        }
                    </div>
                </div>
            </div>
            <ReactConnectElements
                off={off}
                selector=".elements"
                strokeWidth={off ? 2 : 2}
                color="#DEDDE2"
                overlay={toggle ? 1 : 1}
                animations={animations}

                elements={[

                    {from: '.element1', to: '.target-handler'},
                    {from: '.target-handler', to: '.element3'},
                    {from: '.element3', to: '#circle-target'},
                ]}
            />

        </div>
    )
}

export default DemoCreateEls;
